<template> 
<div  v-bind:style="styles.selectButton">
  <button v-bind:style="styles.buttonReportCustom"
          v-on:click="show_hide()">
        {{title}}
  </button>
  <div  v-if="show"
        v-on-clickaway="away"
        :style="style">
    <div id="tableDesc_2">
      <h3 v-if="false" id="cross_2"
          v-on:click="show_hide()">✖</h3>
    </div>
    <div id="container">
      <div id="row_1">
        <h4 id="label_1">Разбиение на:</h4>
        <input type="radio" id="label_1" value="true" v-model="added.row_1">
        <label id="label_1" for="label_1">вкладки</label>
        <input type="radio" id="label_1" value="false" v-model="added.row_1">
        <label id="label_1" for="label_1">колонки</label>
      </div>
      <div id="row_1">
      <h4 id="label_1">Код доходов бюджетов РФ:</h4>
        <input type="radio" id="label_1" value="true" v-model="added.cbc">
        <label id="label_1" for="label_1">Да</label>
        <input type="radio" id="label_1" value="false" v-model="added.cbc">
        <label id="label_1" for="label_1">Нет</label>
      </div>
      <div id="row_1">
      <h4 id="label_1">Код строки:</h4>
        <input type="radio" id="label_1" value="true" v-model="added.code">
        <label id="label_1" for="label_1">Да</label>
        <input type="radio" id="label_1" value="false" v-model="added.code">
        <label id="label_1" for="label_1">Нет</label>
      </div>
      <div v-if="false" id="row_1">
        <h4 id="label_1">Разделитель:</h4>
        <input type="radio" id="label_1" value="true" v-model="added.row_2">
        <label id="label_1" for="label_1">запятая</label>
        <input type="radio" id="label_1" value="false" v-model="added.row_2">
        <label id="label_1" for="label_1">точка</label>
      </div>
      <div v-if="false" id="row_1">
        <h4 id="label_1">Пробелы:</h4>
        <input type="radio" id="label_1" value="true" v-model="added.row_3">
        <label id="label_1" for="label_1">да</label>
        <input type="radio" id="label_1" value="false" v-model="added.row_3">
        <label id="label_1" for="label_1">нет</label>
      </div>
      <div v-if="false" id="row_1">
        <h4 id="label_1">Знак валюты:</h4>
        <input type="radio" id="label_1" value="none" v-model="added.row_4">
        <label id="label_1" for="label_1">нет</label>
        <input type="radio" id="label_1" value="first" v-model="added.row_4">
        <label id="label_1" for="label_1">1 руб.</label>
        <input type="radio" id="label_1" value="second" v-model="added.row_4">
        <label id="label_1" for="label_1">1₽</label>
        <input type="radio" id="label_1" value="third" v-model="added.row_4">
        <label id="label_1" for="label_1">₽1</label>
      </div>
    </div>
  </div>
</div>    
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'nestedSelect',
  props: ['title', 'nestedregs', 'top', 'left', 'height', 'selected'],
  mixins: [ clickaway ],
  watch: { 
    added: function(newVal, oldVal) {
      //console.log(newVal, oldVal)
      if (typeof this.nestedregs !== 'undefined') {
        this.added = []
        Array.prototype.forEach.call(this.nestedregs ,element => {
          const index = this.added.indexOf(element.id)
          if (index < 0) this.added.push(element.id)
        })
        this.$emit('update:selected', this.added)
      }
    }
  },
  computed: {
    style () {
      return {
          position: 'fixed',
          zIndex: '120',
          backgroundColor: 'white',
          boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
          width: '300px',
          height: '400px',
          top: this.top,
          left: this.left,
          padding: '0px 10px 0px 10px'
        }
    }
  },
  mounted() {

      this.nestedregs.forEach(element => {
        const index = this.added.indexOf(element.id)
        if (index < 0) this.added.push(element.id)
      }) 
      this.$emit('update:selected', this.selected)
    
  },
  data: function() {
    return {
      added: {
        row_1: true,
        row_2: true,
        cbc: true,
        code: true,
        row_3: true,
        row_4: 'first'
      },
      selected: [
        {name: 'cbc', value: true}
      ],
      opened: [],
      show: false,
      styles: {
        buttonReportCustom: {
          width: '80px',
          height: '30px',
          margin: '0',
          borderWidth: '1px',
          outline: 'none',
          borderRadius: '8px',
          fontSize: '12px',
          backgroundColor: '#f5f5f5',
          cursor: 'pointer',
        },
        selectParameter: {
          position: 'relative',
          zIndex: '100',
          backgroundColor: 'white',
          boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
          width: '300px',
          height: '600px',
          top: '21%',
          left: '2%',
          padding: '0px 10px 0px 10px'
        },
        selectButton: {
          width: '100px',
          height: '30px',
          position: 'relative',
          borderRadius: '8px'
        }
        
      }
    }
  },
  methods: {
    away: function() {
      console.log('clicked away');
      this.show_hide()
    },
    toggle(id) {
      const index = this.opened.indexOf(id);

      this.$emit('update:selected', this.added)

      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    show_hide() {
      if(this.show) {
        this.styles.buttonReportCustom.backgroundColor = '#f5f5f5'
        this.styles.buttonReportCustom.color = 'black'
      } else {
        this.styles.buttonReportCustom.backgroundColor = ' #4d82cb'
        this.styles.buttonReportCustom.color = 'white'
      }
      this.$emit('update:selected', this.added)
      this.show = !this.show
    }

  }
}

</script>

<style>

#tableDesc_2 {
  display: flex;
  flex-flow: flex-end;
  margin-left: 260px;
  background-color: white;
}

#tableParag {
  margin: 12px 0px 15px 0px;
  font-size: 17px;
  font-weight: bold;
}

#buttonSelect {
  width: 120px;
  height: 25px;
  margin: 12px 10px 10px 10px;

  border-width: 0;
  outline: none;
  border-radius: 2px;

  font-size: 11px;
  font-weight: bold;
  color: white;

  background-color: #9e9e9e;

  cursor: pointer;
}

#container {
  display: grid;
  grid-template-rows: 5px, 5px, 5px, 5px, 5px, 5px, 5px;


  position: relative;
  border-style: solid;
  border-width: 1px;
  margin-top: 20px;
  margin-bottom: 0px;
  height: 334px;
}

#row_1 {
  display: inline-flex;
  font-size: 3px;
  height: 30px;
}

#choiceTable {
  width: 100%;
}

#choiceTable td:nth-child(1)  {
  background-color: #4d82cb;
  color: white;
  width: 25px;
  cursor: pointer;
  text-align: center;
}

#choiceTable td:nth-child(2)  {
  width: 195px;
}

#choiceTable td:nth-child(3)  {
  text-align: center;
  cursor: pointer;
}

#subRows td:nth-child(2)  {
  background-color: #f5f5f5;
}

#subRows td:nth-child(3)  {
  background-color: #f5f5f5;
}

h3#cross_2 {
  text-align: center;
  font-size: 20px;
  margin: 12px 12px 0px 10px;
  cursor: pointer;
}

h4#label_1 {
  text-align: center;
  font-size: 12px;
  margin: 6px 2px 0px 14px;
  height: 10px;
  cursor: pointer;
}

input#label_1 {
  text-align: center;
  font-size: 2px;
  margin: 10px 2px 0px 2px;
  cursor: pointer;
}

label#label_1 {
  text-align: center;
  font-size: 12px;
  margin: 6px 2px 0px 4px;
  height: 10px;
  cursor: pointer;
}


#row_1::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#row_1::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#row_1::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#container::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#container::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#container::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#tableDesc_2::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#tableDesc_2::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#tableDesc_2::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#buttonContainer::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#buttonContainer::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#buttonContainer::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

</style>